/**
 * Spike-only stub for `next/image`. Renders a plain <img>. The real
 * migration would either keep this thin wrapper or switch to
 * `vite-imagetools` for build-time srcSet generation; the demo uses
 * small SVG/PNG assets that don't need responsive generation, so the
 * thin <img> wrapper is sufficient.
 */
import type { ImgHTMLAttributes } from "react";

type NextImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  priority?: boolean;        // ignored — no LCP hinting in the spike
  fetchPriority?: "high" | "low" | "auto";
  unoptimized?: boolean;     // ignored — Vite serves as-is
  fill?: boolean;            // ignored — caller wraps in a sized container
};

export default function Image({
  src, alt, width, height, priority: _priority,
  fetchPriority, unoptimized: _unoptimized, fill: _fill,
  ...rest
}: NextImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      fetchPriority={fetchPriority}
      {...rest}
    />
  );
}
